import {
  Edit,
  SimpleForm,
  TextInput,
  usePermissions,
  useNotify,
  useRedirect,
  required,
} from "react-admin";

import { Typography, Divider } from "@mui/material";

const CategoryEdit = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { permissions = [] } = usePermissions();

  if (
    !(
      permissions.includes("assessments.create") ||
      permissions.includes("assessments.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  const handleSuccess = () => {
    notify("Category updated successfully 🎉", { type: "success" });
    redirect("/categories");
  };

  return (
    <Edit
      mutationMode="pessimistic"
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      <SimpleForm
        sx={{
          maxWidth: 600,
          mt: 2,
          p: 2,
        }}
      >
        {/* Header */}
        <Typography variant="h6" gutterBottom>
          Edit Category
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {/* ID */}
        <TextInput source="id" disabled fullWidth />

        {/* Category Name */}
        <TextInput
          source="category_name"
          label="Category Name"
          fullWidth
          validate={required()}
        />

        {/* Subcategory Name */}
        <TextInput
          source="subcategory_name"
          label="Subcategory Name"
          fullWidth
        />

        {/* Description */}
        <TextInput
          source="description"
          label="Description"
          fullWidth
          multiline
          minRows={3}
        />
      </SimpleForm>
    </Edit>
  );
};

export default CategoryEdit;